var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.stepComponent,{tag:"component",on:{"emitirDados":(obj) => _vm.emitir(obj)},model:{value:(_vm.propsPage),callback:function ($$v) {_vm.propsPage=$$v},expression:"propsPage"}})
}
var staticRenderFns = []

export { render, staticRenderFns }